export function PlaygroundTile({
  children,
  className,
  padding = true,
  childrenClassName,
}: {
  children: React.ReactNode
  className?: string
  padding?: boolean
  childrenClassName?: string
}) {
  return (
    <div
      className={`bg-card border border-border rounded-lg overflow-hidden ${className ?? ''}`}
    >
      <div
        className={`h-full ${padding ? 'p-2' : ''} ${childrenClassName ?? ''}`}
      >
        {children}
      </div>
    </div>
  )
}
